<template>
  <ProductTitledBlock
    v-if="product.videos?.items && product.videos.items.length > 0"
    class="mb-5"
    icon=""
    :title="model.title || $t('custom.product_details.videos_block_title')"
  >
    <ProductVideos v-if="product.videos?.items" :videos="product.videos" />
  </ProductTitledBlock>
</template>

<script setup lang="ts">
import { ProductTitledBlock, ProductVideos } from "@/shared/catalog";
import type { Product } from "@/core/api/graphql/types";

defineProps<{
  product: Product;
  model: {
    title: string;
  };
}>();
</script>
